<template>
  <Modal
    v-bind="{ isVisible }"
    cancel-variant="primary"
    confirm-variant="primary-ghost"
    :tracking="{
      action: 'checkout',
      topicKey: 'account_temporarily_limited',
    }"
    @cancel="emit('close')"
    @confirm="() => navigateTo($localePath('/service?chat=true'))"
  >
    <template #headline>
      {{ $t('account.modal.temporarilylimited.title') }}
    </template>
    <section class="flex flex-col items-center">
      <p>{{ $t('account.modal.temporarilylimited.message') }}</p>
      <Illustration name="pending-id-verification" />
    </section>
    <template #confirm>
      {{ $t('account.modal.temporarilylimited.confirm') }}
    </template>
    <template #cancel>
      {{ $t('account.modal.temporarilylimited.cancel') }}
    </template>
  </Modal>
</template>

<script lang="ts" setup>
defineProps<{ isVisible: boolean; redirect?: string }>()
const emit = defineEmits<{ (e: 'close'): void }>()
</script>
